module.exports = __webpack_public_path__ + "static/media/testimonial_image_2.a948fb46.svg";